<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toctitle"><a id="page_6"></a>Contents</h1>
<h3 class="toc"><a href="#/xhtml/08_Introduction">Introduction</a></h3>
<h3 class="toc"><a href="#/xhtml/09_Ch01">Materials &amp; tools</a></h3>
<h3 class="toc"><span href="#/xhtml/10_Ch02" title="Link target outside of Sample">Basic crochet techniques</span></h3>
<h3 class="toc"><span href="#/xhtml/11_Ch03" title="Link target outside of Sample">The projects</span></h3>
<h3 class="toc"><span href="#/xhtml/12_Abbrevation" title="Link target outside of Sample">Abbreviations</span></h3>
<div class="img_container">
<p class="image"><img alt="" src="images/4-1.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-1" title="Link target outside of Sample">SNOWMEN</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-2.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-2" title="Link target outside of Sample">SANTA CLAUS AND MRS CLAUS</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-3.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-3" title="Link target outside of Sample">ELVES</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-4.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-4" title="Link target outside of Sample">REINDEER</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-5.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-5" title="Link target outside of Sample">CHRISTMAS STOCKING</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-6.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-6" title="Link target outside of Sample">CHRISTMAS GIFTS</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-7.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-7" title="Link target outside of Sample">CHRISTMAS CRACKER</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-8.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-8" title="Link target outside of Sample">CHRISTMAS TREE</span></p>
</div>
<div class="img_container">
<p class="image"><a id="page_7"></a><img alt="" src="images/4-9.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-9" title="Link target outside of Sample">ROBIN</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-10.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-10" title="Link target outside of Sample">HOLLY BERRIES</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-11.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-11" title="Link target outside of Sample">CHRISTMAS STAR</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-12.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-12" title="Link target outside of Sample">ANGEL</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-13.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-13" title="Link target outside of Sample">CHRISTMAS PUDDING</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-14.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-14" title="Link target outside of Sample">PENGUIN</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-15.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-15" title="Link target outside of Sample">BRUSSELS SPROUTS</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-16.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-16" title="Link target outside of Sample">MINCE PIES</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-17.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-17" title="Link target outside of Sample">CARROTS</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-18.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-18" title="Link target outside of Sample">PIGS IN BLANKETS</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-19.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-19" title="Link target outside of Sample">GINGERBREAD MAN</span></p>
</div>
<div class="img_container">
<p class="image"><img alt="" src="images/4-20.jpg"/></p>
<p class="figcap"><span href="#/xhtml/11_Ch03#ch-20" title="Link target outside of Sample">POLAR BEAR</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?8f944c14